/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings } from './get-monthly-card-transactions-for-the-user200-response-merged-transaction-detail-list-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheUser200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];


